import VuetifyDefaultTranslations from 'vuetify/lib/locale/en'

export const DateTime = {
    short: {
        year: "numeric",
        month: "short",
        day: "numeric"
    },
    long: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
        hour12: false
    }
};

export default {
    $vuetify: {
        ...VuetifyDefaultTranslations
    },
    es: "Spanish",
    en: "English",
    YES: "Yes",
    NO: "No",
    INSTALL: 'Installed',
    INVENTORY: 'Inventory',
    NOT_ASSIGNED: 'Not Assigned',
    RETIRED: 'Retired',
    RMA: 'RMA',
    REMOVED: 'Removed',
    SWAP: 'Swap',
    UNKNOWN: 'Unknown',
    netMet: "Network Metrics",
    ncs: "Network Command Suite",
    dashboard: "Dashboard",
    channels: "Channels",
    uplinkRoutes: "Uplink Routes",
    downlinkRoutes: "Downlink Routes",
    alarmDashboard: "Alarm Dashboard",
    map: "Map",
    alarmsControl: "Configure Alarms",
    alarms: "Alarms",
    activeAlarms: "Active Alarms",
    graphs: "Graphs",
    devices: "Devices",
    details: "Details",
    endPoints: "Endpoints",
    radios: "Radios",
    towers: "Base Stations",
    radioDetails: "Radio Details",
    radioChannels: 'Radio Channels',
    radioUplinkRoutes: 'Radio Uplink Routes',
    radioDownlinkRoutes: 'Radio Downlink Routes',
    radioHistory: "Radio History",
    radioAlarms: "Radio Alarms",
    radioReads: "Radio Reads",
    radioMap: "Radio Map",
    radioDashboard: "Radio Dashboard",
    radioDeviceDetails: "Radio Device Details",
    tuning: "Tuning",
    configuration: "Configuration",
    commandChannels: "Command Channels",
    bulkChannels: "Bulk Channels",
    baseStation: "Base Station",
    baseStations: "Base Stations",
    status: "Status",
    statistics: "Statistics",
    planning: "Planning",
    config: "Configuration",
    tables: "Tables",
    towerDetails: "Base Station Details",
    towerGraphs: "Base Station Graphs",
    towerDashboard: "Base Station Dashboard",
    towerDetailsDashboard: "Base Station Dashboard",
    towerActiveConfig: "Base Station Active Config",
    towerMap: "Base Station Map",
    towerHistory: "Base Station History",
    towerAlarms: "Base Station Alarms",
    towerConfig: "Base Station Configuration",
    systemPerformanceTabs: "System Performance",
    systemMetrics: "System Metrics",
    systemDashboard: "System Dashboard",
    systemOverview: "System Overview",
    performanceDashboard: "System Performance Dashboard",
    rnis: "RNI Management",
    endPointConfig: "Endpoint Configuration",
    towerTune: "Base Station Tuning",
    endPointTune: "Endpoint Tuning",
    customers: "Customer Management",
    manageReleases:'Manage Releases',
    customerDetails: "Customer Details",
    taskManagement: "Task Management",
    outboundManagement: "Outbound Traffic Management",
    ncsManagement: "NCS Management",
    tuningConfiguration: "Tuning Configuration",
    taskDetails: "Task Details",
    frequencyMappings: "Frequency Mappings",
    frequencyConfiguration: "Frequency Configuration",
    endpointCountsByAlohaFrequency: "Endpoint Counts by ALOHA Frequency",
    endpointCountsByPollFrequency: "Endpoint Counts by Poll Response Frequency",
    endpointCountsByPriorityFrequency: "Endpoint Counts by Priority Frequency",
    endpointCountsByDownlinkFrequency: "Endpoint Counts by Downlink Frequency",
    current: "Current",
    endpoints: "endpoints",
    detailsLinkTT: "Go to details",
    destLinkTT: "Go to destination details",
    detailsPlannedTT: "Planned Value: {plannedValue}",
    launchPad: "Launch Pad",
    launchPadDesc: "Return to Sensus Launch Pad",
    error: {
        noPermsTitle: "You do not have any permissions in the Network Command Suite application",
        noPermsMsg: "Please request Network Command Suite permissions from your System Administrator",
        noCustomersTitle: "You have not been assigned to any customers with Network Command Suite access",
        noCustomersMsg: "Please request Network Command Suite access from your System Administrator",
        genericErrorTitle: "An unexpected error has occurred",
        genericErrorMsg: "Please notify the System Administrator"
    },
    settings: {
        clearPreferences: "Clear Preferences",
        clearAllPrefs: "Clear All Preferences",
        clearCurrentPagePrefs: "Clear Current Page Preferences",
        setPreferences: "Set Preferences",
        setPreferencesDesc: "Set User Preferences"
    },
    statusChipStates: {
        COMPLETED: "Completed",
        COMPLETE: "Complete",
        COMPLETED_WITH_WARNINGS: "Completed with Warnings",
        FAILED: "Failed",
        IMPORTING: "Importing",
        IN_PROGRESS: "In Progress",
        QUEUED: "Queued",
        SUBMITTED: "Submitted",
        SUBMITTED_WITH_WARNINGS: "Submitted with Warnings",
        SUCCESS: "Success",
        VALIDATED: "Validated",
        VALIDATING: "Validating",
    },
    common: {
        date: "Date",
        time: "Time",
        channel: "Channel",
        name: "Name",
        history: "History",
        staleDataWarning: "Have not heard from since {targetValue}, data might be stale",
        uplinkTrafficDropWarning: "Uplink traffic drop alarm state since {targetValue}, data might be stale",
        help: "Help Documentation",
        tutorial: "Interactive Tutorial",
        actions: "Actions",
        addAFilter: "Add A Filter",
        all: "All",
        ok: "OK",
        apply: "Apply",
        save: "Save",
        cancel: "Cancel",
        city: "City",
        close: "Close",
        true: "True",
        false: "False",
        confirm: 'Confirm',
        change: "Change",
        description: "Description",
        confirmDelete: "Confirm Delete",
        confirmDisable: "Confirm Disable",
        clearAllSelectedRows: "Clear All Selected Rows",
        showTune: "Show Tuning",
        showConfig: "Show Configuration",
        showTable: "Show Table",
        showGraph: "Show Graph",
        resetDefaults: 'Reset Defaults',
        defaultValue: 'Default Value',
        rule: 'Rule',
        ncsRoles: "NCS Permissions",
        btsRoles:"Base Station Permissions",
        userPermission: "My Permissions",
        importUserPrefs: "Import Preferences",
        exportUserPrefs: "Export Preferences",
        readUserPrefsError: "Error occured while reading file to import",
        putUserPrefsError:" Error occured while sending prefs to server",
        importSuccess: "Successfully Imported User prefs",
        invalidPrefs:"Failed, Invalid Import File",
        delta: "delta",
        highest: "Highest",
        lowest: "Lowest",
        graphDurations: "Graph Durations",
        graphDuration: "Graph Duration",
        graphIntervals: "Graph Intervals",
        graphInterval: "Graph Interval",
        drilldown: "Drilldown",
        intervals: "Intervals",
        frequency: "Frequency",
        HIGHEST: "Highest",
        LOWEST: "Lowest",
        count: "Count",
        percentage: "Percentage",
        total: "Total",
        to: "to",
        and: "and",
        more: "more",
        returnToTop: "Return to top",
        search: "Search",
        second: "second",
        seconds: "seconds",
        minute: "minute",
        minutes: "minutes",
        day: "day",
        days: "days",
        hour: "hour",
        hours: "hours",
        secondAbbrev: "s",
        dayAbbrev: "d",
        hourAbbrev: "hr",
        minuteAbbrev: "min",
        milesAbbrev: 'mi',
        maximize: 'Maximize',
        minimize: 'Minimize',
        optional: 'Optional',
        noLeadingSpaces: 'Leading spaces are not allowed',
        valueIsRequired: 'Value is required',
        integerIsRequired: 'Whole number is required',
        fetchDataError: 'Unexpected error retrieving data',
        timezone: 'Time Zone',
        timezoneHint: 'Start typing to search for time zones',
        expandAll: 'Expand All',
        collapseAll: 'Collapse All',
        customer: 'Customer',
        threshold: 'Threshold',
        throughput: "Throughput",
        successRate: "Success Rate",
        on: 'ON',
        off: 'OFF',
        exactMatch: 'Exact Match',
        unknown: 'Unknown',
        notset: 'Not Set',
        buddy: 'Buddy',
        notApplicable: 'N/A',
        radioModulationLinkTT: 'Click to display list of radios with the modulation',
        radioFrequencyLinkTT: 'Click to display list of radios with the frequency',
        towerFrequencyLinkTT: 'Click to display list of base stations with the frequency',
        averageMessages: "Average Messages",
        MANUALLY_DISABLED: 'Manually Disabled',
        COMMANDS_TIMING_OUT: 'Commands Timing Out',
        errors: {
            invalidRequestTooManyResults: 'There are too many records to process, please filter the data to get a smaller data set'
        },
        titleBar: {
            searchPlaceholder: "Search by ID or Name ...",
            searchPlaceholderExact: "Search by exact ID or Name ...",
            searchNoMatches: "No matches found",
            searchSearching: "Searching for matches...",
            searchSearchingExact: "Searching for exact match..."
        },
        refreshData: "Refresh the data shown",
        reconnect:"Reconnect to Base Station",
        closeTab: "Close Tab",
        selectCustomer: "Select Customer",
        refreshRate: "Refresh Rate",
        changeActiveCustomer: "Change Active Customer",
        dateTime: "Date Time",
        none: 'None',
        fileTypeErrMsg: 'Acceptable file type(s) are {acceptableFileType} only',
        durationsList: "Durations List",
        rfRegion: "RF Region",
        rfRegions: {
            STANDARD: "Standard",
            FYLINGDALES: "Fylingdales",
            null: "Not Set"
        },
        cancelUpload: "Cancel Upload",
        deploy: "Deploy",
        update: 'Update',
        reboot: "Reboot",
        hide: 'Hide',
        others: "Others",
        edit: "Edit",
        fail: "Fail",
        minimum: 'Min',
        maximum: 'Max',
        filters: 'Filters',
        copyOf: 'Duplicate of ',
        partialCopyOf: 'Selected {type} from ',
        messages: 'Messages',
        copied: 'Copied to Clipboard'
    },
    highcharts: {
        displayChartMenu: "Display chart menu",
        selectOne:"All graph series have been disabled, enabled at least one series to see the data",
        selectOneWithBrTag:"All graph series have<br> been disabled, enabled at <br> least one series to <br> see the data",
        noData: "No data to display",
        loading: "Loading",
        thousandsSep: ',',
        contextButtonTitle: "Chart context menu",
        printChart: "Print Chart",
        downloadPNG: "Download PNG Image",
        downloadJPEG: "Download JPEG Image",
        downloadSVG: "Download SVG Image",
        downloadPDF: "Download PDF Document",
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        resetZoom: "Reset Zoom",
        resetZoomTitle: "Reset zoom level 1:1",
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        weekdays: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        downloadCSV: "Download CSV",
        downloadXLS: "Download XLS"
    },
    graph: {
        duration: "Duration",
        graphs: "Graphs",
        for: "for",
        average: "Average",
        averageSeconds: "Average (seconds)",
        averageMinutes: "Average (minutes)",
        minValue: "Min Value",
        maxValue: "Max Value",
        minute: "Minute",
        hour: "Hour",
        day: "Day",
        last24Hours: "Last 24 Hours",
        last1Days: "Yesterday",
        last7Days: "Last 7 Days",
        last10Days: "Last 10 Days",
        last30Days: "Last 30 Days",
        networkPulse: {
            daily: "Daily",
            last7Days: "Weekly",
            last30Days: "Monthly",
            custom: "Selection",
            radioCountTitle: "View radios reporting below threshold"
        },
        displayChartMenu: "Display chart menu",
        includeToday: "Include Today",
        includeTodayDisabled: "Disabled for custom durations",
        startYAxisAtZero: "Start Y Axis at Zero",
        fitYAxisGuidelines: "Fit Graph to Guidelines",
        stackedArea: "Stacked Area Graph",
        totalValues: "Count",
        dayStartingAt: "Day Start",
        custom: "Custom",
        customDuration: "Custom Duration",
        startDate: "Start Date",
        endDate: "End Date",
        interval: "Interval",
        intervals: "Intervals",
        startDateRequired: "Start Date is required",
        endDateRequired: "End Date is required",
        dataCalc: "Data is being calculated...",
        dashletControlsLoading: "Dashlet control data is being loaded...",
        xAxis: {
            MINUTE: "Minute",
            HOUR: "Hour",
            DAY: "Day"
        },
        other: 'Other',
        not_set: "Not Set",
    },
    ordDeviceTrans: {
        ORD_Device: "Stale Device Date",
        ORD_Device_Datetime: "Stale Date"
    },
    thresholdTrans: {
        above: "Above",
        within: "Within",
        below: "Below",
        notAvailable: "N/A"
    },
    sets: {
        setMenu: "Manage Sets",
        setRequired: "A set is required, create a {link} then reload",
        createSetFromFilter: "Create Set From Filter",
        createSetFromIds: "Create Set From Selected Items",
        createSetFromFile: "Create Set From File",
        deleteSet: "Delete Set",
        addSelectedToSet: "Add Selected Items to Set",
        removeSelectedFromSet: "Remove Selected Items from Set",
        setCreated: 'Set \'{name}\' created successfully',
        setDeleted: 'Set \'{name}\' deleted successfully',
        setUpdated: 'Set \'{name}\' updated successfully',
        setCreatedAsync: 'Create request for set \'{name}\' submitted. Go to History to view the command status.',
        setDeletedAsync: 'Delete request for set \'{name}\' submitted. Go to History to view the command status.',
        setUpdatedAsync: 'Update request for set \'{name}\' submitted. Go to History to view the command status.',
        setCreatedWithInvalidIds: 'The following ids in the file were not valid and were ignored: {ids}',
        selectSet: 'Select Set',
        setName: 'Set Name',
        noSets: 'There are no sets available',
    },
    customDuration: {
        durationStartDate90Error: "When the Start Date is more than 90 days ago, the Interval must be Day",
        durationStartDate30Error: "When the Start Date is more than 30 days ago, the Interval must be Day",
        durationStartDate7Error: "When the Start Date is more than 7 days ago, the Interval must be Hour or Day",
        durationStartDateTodayError: "When the interval is Day, the End Date cannot be set to today",
        durationEndLessThanStartError: 'End Date must be greater than  or equal to Start Date',
        tooManyDaysForMinutesError: "You can only select 'Minute' interval for 1 day",
        tooManyDaysForHoursError: "You can only select 'Hour' interval for up  to {maxDays} days"
    },
    transmit: {
        priority: {
            1: "01 - SCRAM",
            2: "02 - DA",
            3: "03 - MOM-Comm",
            4: "04 - LAT High",
            5: "05 - Operator",
            6: "06 - LAT Normal",
            7: "07 - User 1",
            8: "08 - Time Pings",
            9: "09 - User 2",
            10: "10 - Base Station ACKs",
            11: "11 - User 3",
            12: "12 - User 4",
            13: "13 - User 5",
            14: "14 - User 6",
            15: "15 - User 7"
        }
    },
    other: "Other",
    download: {
        downloadFile: "Download File",
        downloadLimitQuestion: "There are {totalRows} total rows, do you want to download the first {rowLimit} rows?",
        downloadCSV: "Download CSV",
        downloadIdsOnly: "Download Ids Only",
        downloadRadioSortMessage: "Note: Records will be sorted by Rep ID regardless of active sort"
    },
    polling: {
        submittedForCalculate: '{notificationStr} data needs to be calculated, you will be notified when the data is available',
        dataUpdatedRefresh: 'The data {notificationStr} have got updated, refresh the respective item to take effect',
        dataUpdatedLink: 'The data {notificationStr} have got updated, click on below link to take you to the respective page',
    },
    IMPERIAL: {
        "temperature": "Temperature (F)"
    },
    METRIC: {
        "temperature": "Temperature (C)"
    },
    filterboard: {
        groupContainerText: 'Select saved filters',
        min: 'Min',
        max: 'Max',
        disable: "Disable",
        enable: "Enable",
        close: "Close",
        isLoading: "Getting filter data...",
        noData: "No data for this filter",
        excludeItems: "Does Not Match",
        exactMatch: 'Exact Match',
        notset: 'Not Set',
        regex: 'As RegEx'
    },
    filterOperator: {
        EQUALS: '=',
        NOT_EQUALS: '!='
    },
    metryDashboardV4: {
        refresh: 'Refresh',
        maximize: 'Maximize',
        minimize: 'Minimize',
        displayActions: 'Display Actions',
        addModule: 'Add A Dashlet',
        addModuleReadOnly: 'To add dashlets, create a new dashboard.',
        groupContainerText: "Select saved dashlets",
        custom: "Custom",
        close: 'Close'
    },
    metrySideNav: {
        recentlyViewed: "Recently Viewed"
    },
    customDashlet: {
        title: "Create A Custom Dashlet",
        pickDashletToCustomize: "Select Dashlet to Customize",
        loading: "Loading...",
        search: "Search",
        idMinMax: "Choose at least {min} and at most {max} items:",
        setHelpMsg: "Only showing sets with no more than {max} items",
        nameRequired: "Custom Dashlet Name Required",
        dashletRequired: "Dashlet Required",
        close: 'Close',
        name: "Name",
        create: 'Create'
    },
    groupContainer: {
        selectSavedFilter: "Select a saved name",
        createTitle: "Save Configuration As...",
        updateTitle: "Rename",
        badGroupName: "Bad Group Name",
        name: "Name",
        cancel: "Cancel",
        save: "Save",
        ok: "OK",
        nameIsRequired: "Name is required",
        duplicateName: "Name already exists",
        confirmDeleteTitle: "Confirm Delete",
        confirmDelete: "Are you sure you want to delete ",
        search: "Search"
    },
    groupContainerAction: {
        actions: "Actions",
        addModule: "Add Module",
        createNamedGroup: "Create New",
        updateNamedGroup: "Rename",
        deleteNamedGroup: "Delete",
    }
}

